module.exports = __webpack_public_path__ + "static/media/pig2019_1-tc.7ed25d74.jpg";